import React, { useContext } from 'react';
import BookerShortContext from '../../context/bookerShortContext';
import '../../assets/styles/vehicle-info.sass';

const VehicleInfo = () => {
  const { ride, vehicle } = useContext(BookerShortContext);
  const { vehicle_number, driver_name, fleet } = ride || {};
  const { market_type, make, model } = vehicle || {};

  if (!vehicle_number) return <></>;
  return (
    <div className="vehicle-info">
      <div className="vehicle-number">Plate: {vehicle_number}</div>
      <div className="vehicle-type">
        {market_type} {make} {model}
      </div>
      <div className="driver-name">
        <span>{fleet.name}</span>
        <span>{driver_name}</span>
      </div>
    </div>
  );
};

export default VehicleInfo;
